import Welcome from "../sections/welcome";
import About from "../sections/about";
import Tokenomics from "../sections/tokenomics";
import Roadmap from "../sections/roadmap";

export default function Home() {

    return (
          <>
          <Welcome />
          <About />
          <Tokenomics />
          <Roadmap />
          </>
    );
  }